<form id="inputForm" [formGroup]="inputForm" (ngSubmit)="submit()" [hidden]></form>
